import { imageSource } from "@app/constants/image-sources";

export const HomeVisionData = [
  {
    image: imageSource.vision1,
    title: "Customer First",
    description:
      "We aim to create a travel experience where comfort and peace of mind always come first.",
  },
  {
    image: imageSource.vision2,
    title: "Reliable Mobility",
    description:
      "Our vision is to provide vehicles that are safe, reliable, and always road-ready.",
  },
  {
    image: imageSource.vision3,
    title: "Sustainable Future",
    description:
      "We are committed to eco-friendly practices, building a future where mobility and responsibility go hand in hand.",
  },
];

export const numberData = [
  {
    id: 1,
    icon: "mingcute:car-line",
    numbers: "540+",
    category: "Cars",
  },
  {
    id: 2,
    icon: "material-symbols:person-heart-outline",
    numbers: "20k+",
    category: "Customers",
  },
  {
    id: 3,
    icon: "material-symbols:event-available-outline",
    numbers: "25+",
    category: "Years",
  },
  {
    id: 4,
    icon: "ri:speed-up-fill",
    numbers: "20k+",
    category: "Deals",
  },
];

export const modelOptions = [
  { label: "M4", value: "M4" },
  { label: "M3", value: "M3" },
  { label: "M5", value: "M5" },
  { label: "M6", value: "M6" },
];

export const brandsOptions = [
  { label: "Toyota", value: "toyota" },
  { label: "Honda", value: "honda" },
  { label: "SUV", value: "suv" },
  { label: "Sedan", value: "sedan" },
];
